import type { TextBlock } from '@buffer-mono/sp-display'

// receive block and returns text in the format used by the Plate editor
export default function formatTextForEditor(block: TextBlock): string {
  return JSON.stringify([{ type: 'p', children: [{ text: block.text || '' }] }])
}
